export default "GTB BAT-TH-116 — Gestion Technique du Bâtiment classe B/A | Solution Éco France";
